import { defineMessages } from 'react-intl';

import { BuiltinCaptionType } from '../../../models/caption/Caption';

export const messages = defineMessages({
  [BuiltinCaptionType.UPDATE]: {
    id: 'core.category.commands.update',
    defaultMessage: 'Update',
  },
  [BuiltinCaptionType.CREATE]: {
    id: 'core.category.commands.create',
    defaultMessage: 'Create',
  },
  [BuiltinCaptionType.DUPLICATE]: {
    id: 'core.category.commands.duplicate',
    defaultMessage: 'Duplicate',
  },
  [BuiltinCaptionType.EDIT]: {
    id: 'core.category.commands.edit',
    defaultMessage: 'Edit',
  },
  [BuiltinCaptionType.DELETE]: {
    id: 'core.category.commands.delete',
    defaultMessage: 'Delete',
  },
  [BuiltinCaptionType.RESTORE_LINK]: {
    id: 'core.category.commands.restoreLink',
    defaultMessage: 'Restore Link',
  },
  [BuiltinCaptionType.WEAKEN_LINK]: {
    id: 'core.category.commands.weakenLink',
    defaultMessage: 'Weaken Link',
  },
  [BuiltinCaptionType.VIEW]: {
    id: 'core.category.commands.view',
    defaultMessage: 'View',
  },
  [BuiltinCaptionType.FILTER]: {
    id: 'core.category.commands.filter',
    defaultMessage: 'Filter',
  },
  [BuiltinCaptionType.FILTER_BY_COLUMN]: {
    id: 'core.category.commands.filterByColumn',
    defaultMessage: 'Filter By Column',
  },
  [BuiltinCaptionType.CLEAR_COLUMNS_FILTERS]: {
    id: 'core.category.commands.clearColumnsFilters',
    defaultMessage: 'Clear Columns Filters',
  },
  [BuiltinCaptionType.MOVE]: {
    id: 'core.category.commands.move',
    defaultMessage: 'Move',
  },
  [BuiltinCaptionType.COPY]: {
    id: 'core.category.commands.copy',
    defaultMessage: 'Copy cell',
  },
  [BuiltinCaptionType.IMPORT]: {
    id: 'core.category.commands.import',
    defaultMessage: 'Import',
  },
  [BuiltinCaptionType.CSV_EXPORT]: {
    id: 'core.category.commands.export',
    defaultMessage: 'CSV Export',
  },
  [BuiltinCaptionType.EXCEL_EXPORT]: {
    id: 'core.category.commands.excelExport',
    defaultMessage: 'Excel Export',
  },
  [BuiltinCaptionType.SETTINGS]: {
    id: 'core.category.commands.settings',
    defaultMessage: 'Settings',
  },
  [BuiltinCaptionType.TOOLBAR]: {
    id: 'core.category.commands.toolbar',
    defaultMessage: 'Toolbar',
  },
  [BuiltinCaptionType.CATALOGS]: {
    id: 'core.category.commands.catalogs',
    defaultMessage: 'Catalogs',
  },
  [BuiltinCaptionType.WATCH]: {
    id: 'core.category.commands.watch',
    defaultMessage: 'Watch',
  },
  [BuiltinCaptionType.REVIEW]: {
    id: 'core.category.commands.review',
    defaultMessage: 'Review',
  },
  [BuiltinCaptionType.FILE_LINK]: {
    id: 'core.category.commands.linkFile',
    defaultMessage: 'Link file',
  },
  [BuiltinCaptionType.LINKED_FILES]: {
    id: 'core.category.commands.linkedFiles',
    defaultMessage: 'Linked files',
  },
  [BuiltinCaptionType.DOWNLOAD]: {
    id: 'core.category.commands.downloadFile',
    defaultMessage: 'Download file',
  },
  [BuiltinCaptionType.PRINT]: {
    id: 'core.category.commands.print',
    defaultMessage: 'Print report',
  },
  [BuiltinCaptionType.PIVOT]: {
    id: 'core.category.commands.pivot',
    defaultMessage: 'Pivot report',
  },
  [BuiltinCaptionType.SET_PLAN_WORK]: {
    id: 'core.category.commands.planTable',
    defaultMessage: 'Table (plan)',
  },
  [BuiltinCaptionType.SET_FACT_WORK]: {
    id: 'core.category.commands.factTable',
    defaultMessage: 'Table (fact)',
  },
  [BuiltinCaptionType.SET_CALENDAR_WORK]: {
    id: 'core.category.commands.calendarTable',
    defaultMessage: 'Table (calendar)',
  },
  [BuiltinCaptionType.TIME_BOARD]: {
    id: 'core.category.commands.timeBoard',
    defaultMessage: 'Time board',
  },
  [BuiltinCaptionType.DOC_LINKS_GRAPH]: {
    id: 'core.category.commands.docLinksGraph',
    defaultMessage: 'Links graph',
  },
  [BuiltinCaptionType.ACCESS_RIGHTS_ASSIGNMENT]: {
    id: 'core.category.commands.accessRightsAssignment',
    defaultMessage: 'Assignment of access rights',
  },
  [BuiltinCaptionType.ACTION_HISTORY]: {
    id: 'core.category.commands.actionHistory',
    defaultMessage: 'Action history',
  },
  [BuiltinCaptionType.CALCULATE]: {
    id: 'core.category.commands.calculate',
    defaultMessage: 'Calculate',
  },
  [BuiltinCaptionType.CHECK]: {
    id: 'core.category.commands.check',
    defaultMessage: 'Check',
  },
  [BuiltinCaptionType.SHOW_CHECK]: {
    id: 'core.category.commands.showCheck',
    defaultMessage: 'Check protocols',
  },
  [BuiltinCaptionType.INPUT_DOCS]: {
    id: 'core.category.commands.inputDocs',
    defaultMessage: 'Input documents',
  },
  [BuiltinCaptionType.OUTPUT_DOCS]: {
    id: 'core.category.commands.outputDocs',
    defaultMessage: 'Output documents',
  },
  [BuiltinCaptionType.SIGN]: {
    id: 'core.category.commands.sign',
    defaultMessage: 'Sign',
  },
  [BuiltinCaptionType.STORE_VALUES]: {
    id: 'core.category.commands.storeValues',
    defaultMessage: 'Store Values',
  },
  [BuiltinCaptionType.REPORTS]: {
    id: 'core.category.commands.reports',
    defaultMessage: 'Reports',
  },
});
